import { ItemListInformationCollapsible } from "./ItemListInformationCollapsible";

export default ItemListInformationCollapsible;
export { ItemListInformationCollapsible };
